import { faSortDown, faSortUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { InfoOutlined } from "@mui/icons-material";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { TableCell, TableHead, TableRow, Tooltip } from "@mui/material";
import Markdown from "markdown-to-jsx";
import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BrandReachSentimentMeta from "../../../Component/BrandIndexHistory/BrandReachSentimentMeta";
import EmptyView from "../../../Component/EmptyView/EmptyView";
import Modal from "../../../Component/Modal/Modal";
import MUIToolTip from "../../../Component/UI/ActionTooltip/MUIToolTip";
import MUIToolTipBrandAudit from "../../../Component/UI/ActionTooltipBrandAudit/MUIToolTip";
import MUIIconButton from "../../../Component/UI/MUIIconButton/MUIIconButton";
import {
  createActionMetric,
  fetchActionMetrics,
} from "../../../redux/actions/metricActions";
import {
  getDashboardSummary,
  getSourcesWithAlias,
} from "../../../services/apiService";
import { metricExplainations, MONITORING_LLM_LABELS, titleMapping,OVERVIEW_LLM_LABELS, } from "../../../utils/constant";
import {
  coreAttributesDataTransform,
  customizeFontSizeAndStyle,
  extractDomain,
  generateDashboardJsonPrompt,
  prepareComparisonTableData,
  transformDataForMultibarChart,
} from "../../../utils/helpers";
import CustomTooltip from "../common/CustomTooltip";
import DetailedTableModal from "../common/MetricDetails";
import MUIButton from "./../../../Component/UI/MUIButton/MUIButton";
import { createDomainUrlMapping } from "./ActionComponent/ActionModal";
import AttributeBars from "./CompAttributes/CompAttributes";
import {
  formatName,
  sourceSplitToDomain,
} from "./CoreAttributes/CoreAttributes";
import classes from "./DashboardComponent.module.css";
import CustomDateFilter from "../common/CustomDateFilter";

export const dashboardTypeMapping = {
  llm: { type: "LLM", dashboardType: "llmDashboard" },
  market: { type: "Market", dashboardType: "marketDashboard" },
  personas: { type: "Persona", dashboardType: "personaDashboard" },
  category: { type: "Category", dashboardType: "categoryDashboard" },
};

const useQueryParams = () => {
  return new URLSearchParams(useLocation().search);
};

const MultiComparisonComponent = ({
  compCoreAttributes,
  pastCompCoreAttributes,
  compCategoryDimensions,
  pastCompCategoryDimensions,
  brandIndex,
  brandReach,
  brandFav,
  pastIndexScoreObj,
  positiveAttributes,
  negativeAttributes,
  llmDomains,
  geoLogo,
  activeTab,
  brandDomains,
  brandProduct,
  indexScoreMetaData,
  selectedInput,
  type,
  productTaxonomyData,
  customerId,
  categoryDimensionRatingSource,
  coreAttSourceData,
  reachSourceData,
  sentimentSourceData,
  positiveAttSource,
  negativeAttSource,
  sourceURLIds,
  fetchRealTimeActionsSources,
  secCategoryBrandFav,
  secCategoryReach,
  secCategoryBrandIndex,
  pastsecCategoryBrandIndex,
  brandProductCategory,
  secCategoryIndexScoreMetaData,
  isBrandAuditPage,
  isBrandAuditMarketPage,
  activeTarget,
  updateCustomFilterState,
  frequency,
  customDatesToDisplay,
  isOverview = false,
  competitiveOverview = [],
  isMarketOverview = [],
  id="MultiComarison"
}) => {
  console.log("MultiComparisonComponent props:");
  console.log("compCoreAttributes:", compCoreAttributes);
  console.log("pastCompCoreAttributes:", pastCompCoreAttributes);
  console.log("compCategoryDimensions:", compCategoryDimensions);
  console.log("pastCompCategoryDimensions:", pastCompCategoryDimensions);
  console.log("brandIndex:", brandIndex);
  console.log("brandReach:", brandReach);
  console.log("brandFav:", brandFav);
  console.log("pastIndexScoreObj:", pastIndexScoreObj);
  console.log("positiveAttributes:", positiveAttributes);
  console.log("negativeAttributes:", negativeAttributes);
  console.log("llmDomains:", llmDomains);
  console.log("geoLogo:", geoLogo);
  console.log("activeTab:", activeTab);
  console.log("brandDomains:", brandDomains);
  console.log("brandProduct:", brandProduct);
  console.log("indexScoreMetaData:", indexScoreMetaData);
  console.log("selectedInput:", selectedInput);
  console.log("type:", type);
  console.log("productTaxonomyData:", productTaxonomyData);
  console.log("customerId:", customerId);
  console.log("categoryDimensionRatingSource:", categoryDimensionRatingSource);
  console.log("coreAttSourceData:", coreAttSourceData);
  console.log("reachSourceData:", reachSourceData);
  console.log("sentimentSourceData:", sentimentSourceData);
  console.log("positiveAttSource:", positiveAttSource);
  console.log("negativeAttSource:", negativeAttSource);
  console.log("sourceURLIds:", sourceURLIds);
  console.log("fetchRealTimeActionsSources:", fetchRealTimeActionsSources);
  console.log("secCategoryBrandFav:", secCategoryBrandFav);
  console.log("secCategoryReach:", secCategoryReach);
  console.log("secCategoryBrandIndex:", secCategoryBrandIndex);
  console.log("pastsecCategoryBrandIndex:", pastsecCategoryBrandIndex);
  console.log("brandProductCategory:", brandProductCategory);
  console.log("secCategoryIndexScoreMetaData:", secCategoryIndexScoreMetaData);
  const sourceMapping = {
    "Brand Pillars": coreAttSourceData,
    "Purchase Criteria": categoryDimensionRatingSource,
  };
  const [isChecked, setIsChecked] = useState(false);
  const [isDeltaDisplay, setIsDeltaDisplay] = useState(false);
  const [indexScore, setIndexScore] = useState();
  const [reachScore, setReachScore] = useState();
  const [favScore, setFavScore] = useState();
  const [secCategoryIndexScore, setSecCategoryIndexScore] = useState();
  const [secCategoryreachScore, setSecCategoryReachScore] = useState();
  const [secCategoryfavScore, setSecCategoryFavScore] = useState();
  const [summary, setSummary] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [showBrandIndexBreakups, setShowBrandIndexBreakups] = useState(false);
  const [metaData, setMetaData] = useState();
  const [isActionLoading, setIsActionLoading] = useState(false);
  const [expandedRows, setExpandedRows] = useState({}); // Store expanded state for rows
  const [showModal, setShowModal] = useState(false);
  const [selectedMetric, setSelectedMetric] = useState("");
  const [keyPressed, setKeyPressed] = useState(false);
  const dispatch = useDispatch();
  const query = useQueryParams();
  const reporting = query.get("reporting");

  const toggleRow = (attribute) => {
    setExpandedRows((prev) => ({
      ...prev,
      [attribute]: !prev[attribute],
    }));
  };

  useEffect(() => {
    if (isOverview) {
      handleCheckboxChange();
    }
  }, [isOverview])

  useEffect(() => {
    let index = brandIndex;
    let reach = brandReach;
    let fav = brandFav;
    if (!isChecked) {
      index = filteredCompData(brandIndex, brandProduct);
      reach = filteredCompData(brandReach, brandProduct);
      fav = filteredCompData(brandFav, brandProduct);
    }

    setIndexScore(index);
    setReachScore(reach);
    setFavScore(fav);

    // for seconday category

    let secIndex = secCategoryBrandIndex;
    let secReach = secCategoryReach;
    let secFav = secCategoryBrandFav;
    if (!isChecked) {
      secIndex = filteredCompSecCategoryIndexScoreData(secIndex, brandProduct);
      secReach = filteredCompSecCategoryIndexScoreData(secReach, brandProduct);
      secFav = filteredCompSecCategoryIndexScoreData(secFav, brandProduct);
    }

    setSecCategoryIndexScore(secIndex);
    setSecCategoryReachScore(secReach);
    setSecCategoryFavScore(secFav);
  }, [isChecked, selectedInput]);

  // Function to toggle the checkbox
  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const handleDeltaCheckboxChange = () => {
    setIsDeltaDisplay(!isDeltaDisplay);
  };

  const filteredCompData = (data, mainBrand) => {
    if (data && Object?.keys(data).length) {
      let obj = {};
      obj[mainBrand] = data[mainBrand];
      return obj;
    }
  };

  const filteredCompSecCategoryIndexScoreData = (data, mainBrand) => {
    if (!data || !Object.keys(data).length) return {};

    let obj = {};

    Object.keys(data).forEach((categoryId) => {
      if (data[categoryId]?.[mainBrand] !== undefined) {
        obj[categoryId] = {
          [mainBrand]: data[categoryId][mainBrand],
        };
      }
    });

    return obj;
  };

  const handleClickI = (e) => {
    e.shiftKey && setKeyPressed("shiftKey");
    e.altKey && setKeyPressed("altKey");
    setShowModal(true);
  };

  function filterPurchaseDims(DATA1, DATA2) {
    // Extract attributes from DATA1
    if (!DATA1 || DATA1.length === 0) return;
    const data1Attributes = new Set(DATA1.map((item) => item.attribute));
    for (const llm in DATA2) {
      if (DATA2.hasOwnProperty(llm)) {
        DATA2[llm] = Object.fromEntries(
          Object.entries(DATA2[llm]).filter(([attribute]) =>
            data1Attributes.has(attribute)
          )
        );
      }
    }

    return DATA2; // Return the modified DATA2
  }

  const brandProductMetric =
    type == "Product" ? productTaxonomyData : compCoreAttributes;
  const tableData = prepareComparisonTableData(
    brandProductMetric,
    indexScore,
    reachScore,
    favScore,
    compCategoryDimensions,
    pastCompCoreAttributes,
    pastIndexScoreObj?.indexScore,
    pastIndexScoreObj?.rank,
    pastIndexScoreObj?.fav,
    pastCompCategoryDimensions,
    type == "Product",
    isBrandAuditPage,
    isBrandAuditMarketPage,
    {
      secCategoryIndexScore,
      secCategoryreachScore,
      secCategoryfavScore,
      pastsecCategoryBrandIndex,
      brandProductCategory,
      brandProduct,
    },
    isOverview,
    competitiveOverview,
    isMarketOverview,
    selectedInput
  );


  const positiveAttBarChartData =
    transformDataForMultibarChart(positiveAttributes);
  const negativeAttBarChartData =
    transformDataForMultibarChart(negativeAttributes);

  const chartDataArray = [positiveAttBarChartData, negativeAttBarChartData];

  const fetchSummary = async (brandIndex, brandReach, brandFav) => {
    setIsLoading(true);

    const purchaseCriterias = filterPurchaseDims(
      tableData?.tables?.[2]?.rows,
      compCategoryDimensions
    );

    try {
      const produtSpecificMetric =
        type == "Product" ? productTaxonomyData : compCoreAttributes;
      const jsonData = generateDashboardJsonPrompt(
        brandProduct,
        dashboardTypeMapping[activeTab]?.type,
        JSON.stringify(brandIndex),
        JSON.stringify(brandReach),
        JSON.stringify(brandFav),
        JSON.stringify(positiveAttBarChartData),
        JSON.stringify(negativeAttBarChartData),
        produtSpecificMetric,
        purchaseCriterias,
        type == "Product"
      );
      const payload = {
        entity: brandProduct,
        dashboardType: dashboardTypeMapping[activeTab]?.dashboardType,
        jsonData,
        isProduct: type == "Product",
      };
      const response = await getDashboardSummary(payload);
      setSummary(response);
    } catch (error) {
      console.error("Error fetching summary:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const getTruncatedText = () => {
    const words = summary?.split(" ");
    return customizeFontSizeAndStyle(
      words.slice(0, 30).join(" ") + (words.length > 50 ? "...." : ""),
      "18",
      "20"
    );
  };

  function extractGeoAndMarket(input) {
    const match = input.match(/^(.*?)\s*\(([^)]+)\)$/);
    return match ? { geo: match[1].trim(), market: match[2].trim() } : null;
  }

  const handleIndexScoreMetaModal = (
    isMeta,
    brandProductName,
    targetTitle,
    metric,
    score,
    category,
    llm = selectedInput?.llm,
    market = selectedInput?.market
  ) => {
    const reachOrSentiment = metric !== "RBI";
    const isReach = metric === "Reach";
    if (isMeta && reachOrSentiment) {
      const metaData = !category
        ? indexScoreMetaData
        : secCategoryIndexScoreMetaData;
      const filterMeta = metaData?.filter(
        (obj) =>
          obj?.name === brandProductName &&
          obj?.llm ===
          (activeTab === "llm" ? targetTitle : llm) &&
          obj?.category ===
          (activeTab === "category"
            ? targetTitle
            : selectedInput?.category) &&
          obj.market ===
          (activeTab === "market"
            ? extractGeoAndMarket(targetTitle)?.market
            : market) &&
          obj.geography ===
          (activeTab === "market"
            ? extractGeoAndMarket(targetTitle)?.geo
            : selectedInput?.geography) &&
          obj.persona ===
          (activeTab === "personas" ? targetTitle : selectedInput?.persona) &&
          (!category || obj?.categoryName === category)
      );
      if (filterMeta && filterMeta.length && filterMeta?.[0]?.extras) {
        setShowBrandIndexBreakups(true);
        setMetaData({
          data: filterMeta?.[0]?.extras,
          isReach: isReach,
          score,
          targetTitle,
          brandProductName,
          llm,
          market
        });
      }
    }
  };

  const saveActions = async (
    title,
    rationale,
    sources,
    entities,
    realSource
  ) => {
    realSource = sourceSplitToDomain(realSource);
    const llmSources =
      sources && Object.values(sources)?.[0]
        ? Object.keys(Object.values(sources)[0]).slice(0, 5)
        : [];
    let sourceFullUrls = [];
    if (llmSources.length > 0) {
      sourceFullUrls = await getSourcesWithAlias({
        sources: llmSources,
        sourceAliasIds: sourceURLIds,
      });
    }
    const domainUrlMapping = createDomainUrlMapping(sourceFullUrls?.data);
    const finalSource =
      realSource && realSource.length > 0
        ? realSource
        : llmSources.map((url) => ({
          domain_url: url,
          fullUrl: domainUrlMapping?.[url] || "",
        }));

    try {
      const modifiedObj = {
        title,
        rationale,
        brand: selectedInput?.brand || selectedInput?.product,
        persona:
          activeTab === "personas"
            ? entities || metaData?.targetTitle
            : selectedInput?.persona,
        category:
          activeTab === "category"
            ? entities || metaData?.targetTitle
            : selectedInput?.category,
        geography:
          // activeTab === "market"
          //   ? entities || extractGeoAndMarket(metaData?.targetTitle)?.geo
          //   :
          selectedInput?.geography,
        market:
          activeTab === "market"
            ? entities || extractGeoAndMarket(metaData?.targetTitle)?.market
            : metaData?.market,
        llm:
          activeTab === "llm"
            ? entities || metaData?.targetTitle
            : metaData?.llm,
        isProduct: selectedInput?.product ? true : false,
        sources: finalSource,
      };

      // Create the payload
      const payload = {
        action_json: [modifiedObj],
        is_archived: 0,
        is_active: 1,
      };

      // Dispatch the createActionMetric and fetchActionMetrics
      dispatch(createActionMetric(customerId, payload))
        .then(() => {
          dispatch(fetchActionMetrics(customerId))
            .then(() => {
              toast.success("Action Added!", { autoClose: 700 });
            })
            .catch(() => {
              toast.error("Failed to fetch updated metrics!", {
                autoClose: 700,
              });
            });
        })
        .catch(() => {
          toast.error("Something went wrong while creating the action!", {
            autoClose: 700,
          });
        })
        .finally(() => {
          setIsActionLoading(false);
        });
    } catch (error) {
      setIsActionLoading(false);
      toast.error("Failed to fetch source URLs or process the action!", {
        autoClose: 700,
      });
    }
  };

  const getTooltipProps = (
    index,
    metric,
    sources,
    score,
    explanation,
    attribute,
    entity,
    rating,
    sourcesRecord
  ) => {
    let sourceData = [];
    if (sourcesRecord) {
      sourceData = sourcesRecord?.map((source) => ({
        source: source,
        snippet: "",
      }));
    }
    return {
      metric: metric,
      attribute: attribute,
      metricScore: Number(score).toFixed(0),
      selectedInput,
      sources,
      key: index,
      addToActionHandler: saveActions,
      realtimeSources: fetchRealTimeActionsSources,
      actionText: "Add To Action",
      isActionLoading: isActionLoading,
      title: explanation,
      targetKey: entity,
      arrow: true,
      rating,
      sourceData,
      slotProps: {
        popper: {
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, -18],
              },
            },
          ],
        },
      },
    };
  };

  const getValueCell = (
    table,
    val,
    isColorApply,
    valIdx,
    row,
    color,
    sources,
    metric,
    explanation,
    attribute,
    rating
  ) => {
    if (isOverview) {
      let brandScore = val?.value[0]
      let title = titleMapping[table.title] || table.title;
      let brandName = competitiveOverview.length > 0 ? tableData?.headers?.[valIdx] : selectedInput?.brand;
      let category = (competitiveOverview.length > 0 || isMarketOverview.length > 0) ? selectedInput.category : tableData?.headers?.[valIdx];
      let market = isMarketOverview.length > 0 ? tableData?.headers?.[valIdx] :selectedInput?.market;
      return (
        <CustomTooltip >
          <div className="d-flex align-items-center justify-content-center flex-row">
            <span
              style={{
                cursor: "pointer",
                // color: !isColorApply && !val?.isNa ? color : "grey",
                color: brandScore != null &&
                  !isNaN(Number(brandScore)) ? color : "grey",
              }}
              className={`h5 mb-0 me-1  ${classes["main-value"]}`}
              onClick={() => {
                handleIndexScoreMetaModal(
                  true,
                  brandName,
                  category,
                  title,
                  Number(brandScore).toFixed(0),
                  table?.category,
                  row?.attribute,
                  market
                );
              }}
            >
              {brandScore != null &&
                !isNaN(Number(brandScore)) ? Number(brandScore).toFixed(0)
                : "NA"}
            </span>
          </div>
        </CustomTooltip>
      )
    }
    if (table?.type !== "RBI") {
      const targetSources = {
        [tableData?.headers?.[valIdx]]:
          sources?.[tableData?.headers?.[valIdx]] ||
          sources?.[selectedInput?.llm],
      };
      return (
        isBrandAuditPage ? (<MUIToolTipBrandAudit
          {...getTooltipProps(
            undefined,
            metric,
            targetSources,
            val.value,
            explanation,
            attribute,
            tableData?.headers?.[valIdx],
            rating,
            val.sources
          )}
        >
          <div className="d-flex align-items-center justify-content-center flex-row">
            <span
              style={{
                cursor: "pointer",
                // color: !isColorApply && !val?.isNa ? color : "grey",
                color: val.value ? color : "grey",
              }}
              className={`h5 mb-0 me-1  ${classes["main-value"]}`}
            >
              {val?.value != null &&
                !isNaN(Number(val.value)) &&
                (table.title == "Rank" || val.value != 0)
                ? Number(val.value).toFixed(0)
                : "NA"}
            </span>

            {val?.change != undefined && !val?.isNa && isDeltaDisplay && (
              <>
                <FontAwesomeIcon
                  className={
                    val?.change < 0
                      ? `${classes["down-icon"]} text-danger me-1`
                      : `${classes["up-icon"]} text-success me-1`
                  }
                  icon={val?.change < 0 ? faSortDown : faSortUp}
                />
                <span className={classes.delta}>
                  {val?.change > 0
                    ? `${Number(val?.change).toFixed(0)}`
                    : Number(Math.abs(val?.change)).toFixed(0)}
                </span>
              </>
            )}
          </div>
        </MUIToolTipBrandAudit>) :
          (<MUIToolTip
            {...getTooltipProps(
              undefined,
              metric,
              targetSources,
              val.value,
              explanation,
              attribute,
              tableData?.headers?.[valIdx],
              rating,
              val.sources
            )}
          >
            <div className="d-flex align-items-center justify-content-center flex-row">
              <span
                style={{
                  cursor: "pointer",
                  // color: !isColorApply && !val?.isNa ? color : "grey",
                  color: val.value ? color : "grey",
                }}
                className={`h5 mb-0 me-1  ${classes["main-value"]}`}
              >
                {val?.value != null &&
                  !isNaN(Number(val.value)) &&
                  (table.title == "Rank" || val.value != 0)
                  ? Number(val.value).toFixed(0)
                  : "NA"}
              </span>

              {val?.change != undefined && !val?.isNa && isDeltaDisplay && (
                <>
                  <FontAwesomeIcon
                    className={
                      val?.change < 0
                        ? `${classes["down-icon"]} text-danger me-1`
                        : `${classes["up-icon"]} text-success me-1`
                    }
                    icon={val?.change < 0 ? faSortDown : faSortUp}
                  />
                  <span className={classes.delta}>
                    {val?.change > 0
                      ? `${Number(val?.change).toFixed(0)}`
                      : Number(Math.abs(val?.change)).toFixed(0)}
                  </span>
                </>
              )}
            </div>
          </MUIToolTip>)
      );
    }

    if (!val?.rbivalue) {
      return <span> NA </span>;
    }
    return (
      <CustomTooltip explanation={val?.explanation}>
        <div className="d-flex align-items-center justify-content-center">
          {/* Top Main RBI value with change */}
          <div className="d-flex align-items-center mb-1">
            <span
              style={{
                cursor: "auto",
                color: "grey",
                fontSize: "16px",
                fontWeight: 600,
              }}
            >
              {val?.rbivalue != null && !isNaN(Number(val?.rbivalue))
                ? Number(val?.rbivalue).toFixed(0)
                : "NA"}
            </span>
          </div>
          {/* RBI Change */}
          {val?.rbichange !== undefined && !val?.isNa && isDeltaDisplay && (
            <div className="d-flex align-items-center ms-1">
              <FontAwesomeIcon
                className={
                  val?.rbichange < 0
                    ? `${classes["down-icon"]} text-danger`
                    : `${classes["up-icon"]} text-success`
                }
                icon={val?.rbichange < 0 ? faSortDown : faSortUp}
                style={{ fontSize: "12px" }}
              />
              <span
                className={classes.delta}
                style={{ fontSize: "12px", marginLeft: "2px" }}
              >
                {val?.rbichange > 0
                  ? `${Number(val?.rbichange).toFixed(0)}`
                  : Number(Math.abs(val?.rbichange)).toFixed(0)}
              </span>
            </div>
          )}
          &nbsp;
          <div className="d-flex flex-column align-items-center justify-content-center">
            <div className="d-flex align-items-center justify-content-center">
              <span
                onClick={() => {
                  handleIndexScoreMetaModal(
                    isColorApply,
                    row.attribute,
                    tableData?.headers?.[valIdx],
                    "Reach",
                    Number(val?.rbrvalue).toFixed(0),
                    table?.category
                  );
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = "#2196F3";
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = "grey";
                }}
                style={{
                  cursor: "pointer",
                  color: "grey",
                  fontSize: "16px",
                  fontWeight: 600,
                }}
              >
                {val?.rbrvalue != null && !isNaN(Number(val?.rbrvalue))
                  ? Number(val?.rbrvalue).toFixed(0)
                  : "NA"}
              </span>
              {val?.rbrchange !== undefined && !val?.isNa && isDeltaDisplay && (
                <>
                  &nbsp;
                  <FontAwesomeIcon
                    className={
                      val?.rbrchange < 0
                        ? `${classes["down-icon"]} text-danger`
                        : `${classes["up-icon"]} text-success`
                    }
                    icon={val?.rbrchange < 0 ? faSortDown : faSortUp}
                    style={{ fontSize: "10px" }}
                  />
                  <span className={classes.delta} style={{ fontSize: "12px" }}>
                    {val?.rbrchange > 0
                      ? `${Number(val?.rbrchange).toFixed(0)}`
                      : Number(Math.abs(val?.rbrchange)).toFixed(0)}
                  </span>
                </>
              )}
            </div>

            {/* Divider Line */}
            <div
              style={{
                width: "75%",
                borderTop: "1px solid grey",
                margin: "2px auto",
              }}
            />

            <div className="d-flex align-items-center justify-content-center">
              <span
                onClick={() => {
                  handleIndexScoreMetaModal(
                    isColorApply,
                    row.attribute,
                    tableData?.headers?.[valIdx],
                    "Sentiment",
                    Number(val?.rbfvalue).toFixed(0),
                    table?.category
                  );
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = "#2196F3";
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = "grey";
                }}
                style={{
                  cursor: "pointer",
                  color: "grey",
                  fontSize: "16px",
                  fontWeight: 600,
                }}
              >
                {val?.rbfvalue != null && !isNaN(Number(val?.rbfvalue))
                  ? Number(val?.rbfvalue).toFixed(0)
                  : "NA"}
              </span>
              {val?.rbfchange !== undefined && !val?.isNa && isDeltaDisplay && (
                <>
                  &nbsp;
                  <FontAwesomeIcon
                    className={
                      val?.rbfchange < 0
                        ? `${classes["down-icon"]} text-danger`
                        : `${classes["up-icon"]} text-success`
                    }
                    icon={val?.rbfchange < 0 ? faSortDown : faSortUp}
                    style={{ fontSize: "10px" }}
                  />
                  <span
                    className={classes.delta}
                    style={{ fontSize: "12px", marginLeft: "2px" }}
                  >
                    {val?.rbfchange > 0
                      ? `${Number(val?.rbfchange).toFixed(0)}`
                      : Number(Math.abs(val?.rbfchange)).toFixed(0)}
                  </span>
                </>
              )}
            </div>
          </div>
        </div>
      </CustomTooltip>
    );
  };

  if (!tableData) {
    return;
  }

  let coreAttributesData =
    (compCoreAttributes &&
      coreAttributesDataTransform(compCoreAttributes, brandProduct)) ||
    [];

  let purchaseDimData =
    compCategoryDimensions &&
    coreAttributesDataTransform(compCategoryDimensions, brandProduct);

  const metricDatalookUp = {
    "Brand Pillars": coreAttributesData,
    "Purchase Criteria": purchaseDimData,
  };

  function getColorCode(value, minValue, maxValue, values) {
    if (minValue > maxValue) {
      console.error("minValue must be less than maxValue");
    }
    const median = minValue + (maxValue - minValue) / 2;
    const top25 = maxValue - ((maxValue - minValue) * 0.25);

    let color;
    let rating;
    if (value < median) {
      color = "#dc3545"; // Red
    } else if (value >= median && value <= top25) {
      color = "#f77103"; // Yellow
    } else {
      color = "#198754"; // Green
    }

    return { color, rating: undefined };
  }


  const getColorAndRating = (tableTitle, val) => {
    if (tableTitle === "Favorability") return { color: undefined, rating: undefined };
    let color = "#dc3545"; // default red
    let rating = "low";

    if (tableTitle === "Rank") {
      const score = Number(val?.value[0]).toFixed(0);
      if (score > 0 && score <= 30) {
        color = "#f77103"; // yellow
      } else if (score >= 31) {
        color = "#198754"; // green
      }
      return { color, rating: undefined };
    }

    // RBI or default case
    if (Number(val?.value).toFixed(0) >= 9) {
      rating = "high";
      color = "#198754";
    } else if (Number(val?.value).toFixed(0) >= 7) {
      rating = "fair";
      color = "#2196F3";
    }

    return { color, rating };
  };


  function renderHeaders() {
    const headers = [selectedMetric, ...tableData?.headers];

    return (
      <TableHead className={classes.table_head}>
        <TableRow>
          {headers.map((header, index) => {
            const extractGeo = header.split("(")[0].trim().replace(/\s+/g, "");

            return (
              <TableCell key={index} className={classes.table_head_cell}>
                <div className={classes.table_head_content}>
                  {index !== 0 ? (
                    activeTab !== "llm" ? (
                      geoLogo?.[extractGeo] && (
                        <img
                          className={classes?.logo}
                          src={`https://flagcdn.com/40x30/${geoLogo?.[extractGeo]}.png`}
                          alt={""}
                        />
                      )
                    ) : (
                      <img
                        className={classes?.logo}
                        src={
                          header === "llm-web"
                            ? "/menu.png"
                            : extractDomain(llmDomains?.[header]) ===
                              "google.com"
                              ? "https://www.gstatic.com/lamda/images/gemini_sparkle_v002_d4735304ff6292a690345.svg"
                              : `https://img.logo.dev/${extractDomain(
                                llmDomains?.[header]
                              )}?token=pk_SaDf4t2eRsW5Fc84zgJRZA`
                        }
                        alt={""}
                      />
                    )
                  ) : null}
                  <div
                    className={
                      index === 0
                        ? classes.table_head_text_comp
                        : classes.table_head_text
                    }
                  >
                    <div className={classes.table_head_title}>
                      <span>
                        <Tooltip title={metricExplainations[header]}>
                          {header}
                        </Tooltip>
                      </span>
                    </div>
                  </div>
                </div>
              </TableCell>
            );
          })}
        </TableRow>
      </TableHead>
    );
  }

  return (
    <div id={id} >

      {frequency === 'Custom' && <CustomDateFilter
        activeTarget={activeTarget}
        handleChange={updateCustomFilterState}
        customDatesToDisplay={customDatesToDisplay}
      />}
      <DetailedTableModal
        show={showModal}
        onClose={() => {
          setKeyPressed(false);
          setShowModal(false);
        }}
        headers={tableData?.headers}
        renderHeaders={renderHeaders}
        data={metricDatalookUp?.[selectedMetric] || []}
        formatName={formatName}
        classes={classes}
        pdfHeight={400}
        pdfTitle={`${selectedInput?.brand || selectedInput?.product
          }-${selectedMetric}`}
        showSplitTables={keyPressed}
      />
      <Modal
        open={showBrandIndexBreakups}
        handleClose={() => setShowBrandIndexBreakups(false)}
        width={1200}
      >
        <BrandReachSentimentMeta
          isReach={metaData?.isReach}
          data={metaData?.data}
          addToActionHandler={saveActions}
          sources={{
            reachSourceData: {
              [metaData?.targetTitle]:
                reachSourceData?.[metaData?.targetTitle] ||
                reachSourceData?.[selectedInput?.llm],
            },
            sentimentSourceData: {
              [metaData?.targetTitle]:
                sentimentSourceData?.[metaData?.targetTitle] ||
                sentimentSourceData?.[selectedInput?.llm],
            },
          }}
          selectedBrandProduct={metaData?.brandProductName}
          score={metaData?.score}
          isMainBrand={metaData?.brandProductName == brandProduct}
          type={type}
        />
      </Modal>

      <br />

      {!isBrandAuditPage && (
        <div className="col-md-12">
          <div className="graphGreyBg">
            <p style={{ display: "flex", justifyContent: "center" }}>
              <h4>Headlines</h4>
              &nbsp; &nbsp;
              <MUIButton
                onClick={() => {
                  fetchSummary(indexScore, reachScore, favScore);
                }}
                variant="outlined"
                className={classes.regenerate}
                startIcon={<AutoAwesomeOutlinedIcon />}
                disabled={isChecked}
              >
                Generate
              </MUIButton>
            </p>
            <div className="graphsummary font-11">
              {isLoading ? (
                <div
                  style={{
                    fontSize: "19px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "20px",
                    // color: "green",
                  }}
                >
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  &nbsp; Loading...
                </div>
              ) : summary && typeof summary === "string" && !isChecked ? (
                <>
                  <Markdown className="markTable">
                    {isExpanded
                      ? customizeFontSizeAndStyle(summary, "18", "20")
                      : getTruncatedText()}
                  </Markdown>
                  <span
                    style={{ cursor: "pointer", color: "blue" }}
                    onClick={() => setIsExpanded(!isExpanded)}
                  >
                    {isExpanded ? "Show Less" : "Show More"}
                  </span>
                </>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      )}
      {!isOverview &&
        <div
          style={{ fontSize: "15px", marginTop: "12px", marginBottom: "-4px" }}
        >
          <label id="show_competitor">
            <input
              style={{}}
              type="checkbox"
              checked={isChecked}
              onChange={handleCheckboxChange}
            />
            &nbsp;
            {"Show Competitor"}
          </label>
          &nbsp;
          {!isBrandAuditPage && (
            <label>
              <input
                style={{}}
                type="checkbox"
                checked={isDeltaDisplay}
                onChange={handleDeltaCheckboxChange}
              />
              &nbsp;
              {"Show Change Data"}
            </label>
          )}
        </div>
      }

      <div className={`${isOverview ? "row" : "col-md-12"} mt-4`}>
        {tableData.tables.map((table, tableIndex) => (
          <React.Fragment key={tableIndex} >
            <div className={`${isOverview ? "col-md-6 mb-4" : ""}`}>
              <div className="card custCard mb-4" id={table.id}>
                <table className="table table-striped mb-0">
                  <thead>
                    <tr className="tblHeader text-center">
                      <th
                        scope="col"
                        style={{
                          width: "150px",
                          textAlign: "left",
                          paddingLeft: "15px",
                          verticalAlign: "middle",
                        }}
                      >
                        <div className={classes.table_head_title}>
                          <span>
                            <Tooltip
                              title={
                                metricExplainations[titleMapping[table.title]]
                              }
                            >
                              <span
                                style={{
                                  color: "black",
                                  fontSize: "1rem",
                                  fontWeight: "500",
                                }}
                              >
                                {table.title === "Rank" && isOverview
                                  ? "Visibility"
                                  : titleMapping[table.title] || table.title}
                              </span>
                            </Tooltip>
                          </span>
                          {(table.title === "Brand Pillars" ||
                            table.title === "Purchase Criteria") && (
                              <MUIIconButton
                                onClick={(e) => {
                                  handleClickI(e);
                                  setSelectedMetric(table.title);
                                }}
                              >
                                <InfoOutlined />
                              </MUIIconButton>
                            )}
                        </div>
                      </th>

                      {tableData.headers.map((header, idx) => {
                        const extractGeo = header
                          .split("(")[0]
                          .trim()
                          .replace(/\s+/g, "");
                        return (
                          <th
                            scope="col"
                            key={idx}
                            className={classes["comp-logo-header"]}
                          >
                            {(!isOverview && (tableIndex === 0 || reporting)) && (
                              <div className={classes["comp-logos"]}>
                                {activeTab !== "llm" ? (
                                  geoLogo?.[extractGeo] && (
                                    <img
                                      className={classes?.logo}
                                      src={`https://flagcdn.com/40x30/${geoLogo?.[extractGeo]}.png`}
                                      alt={""}
                                    />
                                  )
                                ) : (
                                  <img
                                    className={classes?.logo}
                                    src={
                                      header === "llm-web"
                                        ? "/menu.png"
                                        : extractDomain(llmDomains?.[header]) ===
                                          "google.com"
                                          ? "https://www.gstatic.com/lamda/images/gemini_sparkle_v002_d4735304ff6292a690345.svg"
                                          : `https://img.logo.dev/${extractDomain(
                                            llmDomains?.[header]
                                          )}?token=pk_SaDf4t2eRsW5Fc84zgJRZA`
                                    }
                                    alt={""}
                                  />
                                )}
                                <span
                                  style={{
                                    wordWrap: "break-word", // Ensures long text wraps
                                    textAlign: "center",
                                    marginTop: "5px", // Adds space between logo and text
                                  }}
                                >
                                  {MONITORING_LLM_LABELS?.[header] || header}
                                </span>
                              </div>
                            )}
                            {isOverview &&
                              <div className={classes.table_head_content}>
                                {brandDomains?.[header] ? (
                                  <>
                                    <img
                                      className={classes.table_head_logo}
                                      src={`https://img.logo.dev/${extractDomain(
                                        brandDomains?.[header]
                                      )}?token=pk_SaDf4t2eRsW5Fc84zgJRZA`}
                                      alt={""}
                                    />
                                    <div className={classes.table_head_text}>
                                      <div className={classes.table_head_title}>
                                        <span>
                                          {MONITORING_LLM_LABELS?.[header] || header}
                                        </span>
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <span
                                    style={{
                                      wordWrap: "break-word", // Ensures long text wraps
                                      textAlign: "center",
                                      marginTop: "5px", // Adds space between logo and text
                                    }}
                                  >
                                    {MONITORING_LLM_LABELS?.[header] || header}
                                  </span>
                                )
                                }
                              </div>
                            }
                          </th>
                        );
                      })}
                    </tr>
                  </thead>

                  <tbody>
                    {table?.rows && table?.rows?.length ? (
                      table.rows?.map((row, idx) => {
                        const isProductDimensions =
                          table.title === "Product Dimensions";
                        // const isParentRow = !row.values?.[0]?.parentCategory;
                        const isParentRow = row.values?.every(
                          (val) => !val?.parentCategory
                        );
                        const isExpanded = expandedRows[row.attribute];

                        if (isProductDimensions) {
                          if (isParentRow) {
                            // Parent Row for Product dimensions
                            return (
                              <React.Fragment key={idx}>
                                <tr>
                                  <td
                                    valign="middle"
                                    style={{
                                      width: "150px",
                                      textAlign: "left",
                                      paddingLeft: "10px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => toggleRow(row.attribute)}
                                  >
                                    {isExpanded ? (
                                      <KeyboardArrowUpIcon />
                                    ) : (
                                      <KeyboardArrowDownIcon />
                                    )}
                                    &nbsp;
                                    {titleMapping?.[row.attribute] ||
                                      row.attribute}
                                  </td>
                                  {row.values
                                    // .slice(startIndex, startIndex + pageSize)
                                    .map((val, valIdx) => {
                                      const isColorApply =
                                        table?.title == "RBI" ||
                                        table?.title == "Rank" ||
                                        table?.title == "Favorability";
                                      let color = "#dc3545";
                                      let rating = "low";
                                      if (Number(val?.value).toFixed(0) >= 7) {
                                        rating = "fair";
                                        color = "#2196F3";
                                      }
                                      if (Number(val?.value).toFixed(0) >= 9) {
                                        rating = "high";
                                        color = "#198754";
                                      }
                                      return (
                                        <td
                                          key={valIdx}
                                          style={{
                                            width: "100px",
                                            textAlign: "center",
                                          }}
                                        >
                                          {getValueCell(
                                            table,
                                            val,
                                            isColorApply,
                                            valIdx,
                                            row,
                                            color,
                                            sourceMapping?.[table.title],
                                            titleMapping[table.title],
                                            val?.explaination,
                                            row.attribute,
                                            rating,
                                          )}
                                        </td>
                                      );
                                    })}
                                </tr>

                                {/* Subcategories */}
                                {isExpanded &&
                                  // table.rows
                                  //   .filter(
                                  //     (subRow) =>
                                  //       subRow.values?.[0]?.parentCategory ===
                                  //       row.attribute
                                  //   )
                                  table.rows
                                    .filter((subRow) =>
                                      subRow.values?.some(
                                        (val) =>
                                          val?.parentCategory === row.attribute
                                      )
                                    )
                                    .map((subRow, subIdx) => (
                                      <tr key={`sub-${subIdx}`}>
                                        <td
                                          valign="middle"
                                          style={{
                                            width: "150px",
                                            textAlign: "left",
                                            paddingLeft: "42px",
                                          }}
                                        >
                                          {titleMapping?.[subRow.attribute] ||
                                            subRow.attribute}
                                        </td>
                                        {subRow.values.map((val, valIdx) => {
                                          const isColorApply =
                                            table?.title == "RBI" ||
                                            table?.title == "Rank" ||
                                            table?.title == "Favorability";
                                          let color = "#dc3545";
                                          if (Number(val?.value).toFixed(0) >= 7)
                                            color = "#2196F3";
                                          if (Number(val?.value).toFixed(0) >= 9)
                                            color = "#198754";
                                          return (
                                            <td
                                              key={valIdx}
                                              style={{
                                                width: "100px",
                                                textAlign: "center",
                                                // cursor: "pointer",
                                              }}
                                            >
                                              <CustomTooltip
                                                explaination={val?.explaination}
                                              >
                                                <div
                                                  // title={val?.explaination}
                                                  className="d-flex align-items-center justify-content-center flex-row"
                                                >
                                                  <span
                                                    style={{
                                                      cursor: "pointer",
                                                      // color:
                                                      //   !isColorApply &&
                                                      //     !val?.isNa
                                                      //     ? color
                                                      //     : "grey",
                                                      color: val.value ? color : "grey"
                                                    }}
                                                    className={`h5 mb-0 me-1
                              } ${classes["main-value"]}`}
                                                  >
                                                    {val?.value != null &&
                                                      !isNaN(Number(val.value)) &&
                                                      (table.title == "Rank" ||
                                                        val.value != 0)
                                                      ? Number(val.value).toFixed(
                                                        0
                                                      )
                                                      : "NA"}
                                                  </span>
                                                  {val?.change != undefined &&
                                                    !val?.isNa &&
                                                    isChecked && (
                                                      <>
                                                        <FontAwesomeIcon
                                                          className={
                                                            val?.change < 0
                                                              ? `${classes["down-icon"]} text-danger me-1`
                                                              : `${classes["up-icon"]} text-success me-1`
                                                          }
                                                          icon={
                                                            val?.change < 0
                                                              ? faSortDown
                                                              : faSortUp
                                                          }
                                                        />
                                                        <span
                                                          className={
                                                            classes.delta
                                                          }
                                                        >
                                                          {val?.change > 0
                                                            ? `${Number(
                                                              val?.change
                                                            ).toFixed(0)}`
                                                            : Number(
                                                              Math.abs(
                                                                val?.change
                                                              )
                                                            ).toFixed(0)}
                                                        </span>
                                                      </>
                                                    )}
                                                </div>
                                              </CustomTooltip>
                                            </td>
                                          );
                                        })}
                                      </tr>
                                    ))}
                              </React.Fragment>
                            );
                          }

                          return null; // Skip subcategory rows initially for Product dimensions
                        }

                        return (
                          <tr key={idx}>
                            {brandDomains?.[row?.attribute] ? (
                              <>
                                <td
                                  valign="middle"
                                  style={{
                                    width: "150px",
                                    textAlign: "left",
                                    paddingLeft: "15px",
                                  }}
                                >
                                  <img
                                    style={{
                                      width: "20px",
                                      height: "20px",
                                      borderRadius: "6px",
                                      marginBottom: "5px", // Adds spacing between logo and text
                                      objectFit: "contain",
                                    }}
                                    src={`https://img.logo.dev/${extractDomain(
                                      brandDomains?.[row?.attribute]
                                    )}?token=pk_SaDf4t2eRsW5Fc84zgJRZA`}
                                    alt={""}
                                  />
                                  &nbsp;
                                  {row.attribute}
                                </td>
                              </>
                            ) : (
                              <td
                                // valign="middle"
                                style={{
                                  width: "150px",
                                  textAlign: "left",
                                  paddingLeft: row?.values?.[0]?.parentCategory
                                    ? "25px"
                                    : "15px",
                                }}
                              >
                                <Tooltip
                                  title={metricExplainations[row.attribute]}
                                >
                                  {isOverview ? OVERVIEW_LLM_LABELS?.[row.attribute] : row.attribute}
                                </Tooltip>
                              </td>
                            )}
                            {row.values.map((val, valIdx) => {
                              const isColorApply = table?.type == "RBI";
                              let color, rating;
                              if (table.title === "Favorability" && val.value.length > 0) {
                                let favObj = val.value
                                // Find min & max
                                let minValue = Math.min(...favObj);
                                let maxValue = Math.max(...favObj);
                                ({ color, rating } = getColorCode(val.value[0], minValue, maxValue, favObj));
                              } else {
                                ({ color, rating } = getColorAndRating(table.title, val));
                              }

                              return (
                                <td
                                  key={valIdx}
                                  style={{
                                    width: "100px",
                                    textAlign: "center",
                                    // cursor: "pointer",
                                  }}
                                >
                                  {getValueCell(
                                    table,
                                    val,
                                    isColorApply,
                                    valIdx,
                                    row,
                                    color,
                                    sourceMapping?.[table.title],
                                    titleMapping[table.title],
                                    val?.explaination,
                                    row.attribute,
                                    rating
                                  )}
                                </td>
                              );
                            })}
                          </tr>
                        );
                      })
                    ) : (
                      <EmptyView message="Data Not Available" />
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </React.Fragment>
        ))}
      </div>

      {!isBrandAuditMarketPage &&
        <AttributeBars
          negativeAttributes={negativeAttBarChartData}
          positiveAttributes={positiveAttBarChartData}
        />
      }

      {/* {chartDataArray?.map((data, index) => {
        return (
          <div className="col-md-12 mt-4">
            <div className="card p-3 custCard">
              <div className="mb-3 d-flex justify-content-between align-items-center"></div>
              <div>
                <ReMultibarChart
                  mainIndex={index}
                  data={data}
                  selectedInput={selectedInput}
                  sources={negativeAttSource}
                  saveActions={saveActions}
                  isActionLoading={isActionLoading}
                />
              </div>
            </div>
          </div>
        );
      })} */}

      <ToastContainer />
    </div>
  );
};

export default MultiComparisonComponent;
